<template>
  <node-view-wrapper class="cta-container" contenteditable="false">
    <span>
      <el-popover
        placement="bottom-start"
        trigger="click"
        persistent="false"
        :width="350"
        v-model="visible"
        transition="el-zoom-in-top"
        class="cta-popover"
        @show="focusInput"
        popper-class="cta-popover"
      >
        <template slot="reference">
          <span class="cta-element cursor-move" :class="{ selected: visible }" draggable="true" data-drag-handle>
            <div class="grabber w-6 h-6 absolute top-5 left-3 z-10">
              <font-awesome-icon :icon="['fas', 'grip-vertical']" class="text-brand-dark-sand text-2xl hover:text-brand-brown" />
            </div>
            <el-button type="primary" class="my-3 mx-auto block content-center">{{ text  }}</el-button>
            <button @click="deleteNode" class="delete-button">
              <font-awesome-icon :icon="['fas', 'times-circle']" class="text-lg text-red-300 hover:text-red-500"></font-awesome-icon>
            </button>
          </span>
        </template>
        <template slot="default">
          <div class="bg-white border-brand-sand border-2 rounded-xl relative">
            <div class="bg-brand-light-sand py-2 px-3 text-left rounded-tl-lg rounded-tr-lg border-b-2 border-brand-sand">
              <span class="text-sm leading-6 font-bold text-black">Customize the Call to Action</span>
            </div>
            <div>
              <div class="flex flex-col">
                <div class="flex flex-row">
                  <div class="flex flex-col shrink border-r-2 border-brand-sand p-3">
                    <label class="text-sm leading-6 text-brand-brown font-bold">Button Label</label>
                  </div>
                  <div class="flex flex-col grow p-3">
                    <input
                      tabindex="0"
                      v-model="editableText"
                      ref="textInput"
                      v-on:keydown.enter="onEnter"
                      v-on:change="updateText"
                      :placeholder="defaultText"
                      class="text-sm leading-6 text-brand-blue outline-none focus:outline-none"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </el-popover>
    </span>
  </node-view-wrapper>
</template>

<script>
import Vue from 'vue';
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-2';
import { DUNNING_DEFAULT_CTA_TEXT } from '@/store/shared';

export default Vue.extend({
  components: {
    NodeViewWrapper,
  },
  props: nodeViewProps,
  data: () => ({
    visible: false, // is popover open?
    editableText: '', // temporary value for editing text
    defaultText: DUNNING_DEFAULT_CTA_TEXT,
  }),
  computed: {
    text() {
      return this.node.attrs.text || DUNNING_DEFAULT_CTA_TEXT;
    },
  },
  mounted() {
    this.editableText = this.text;
    // The "open" attribute is used to open the popover when the CTA is first inserted:
    if (this.node.attrs.open) {
      this.visible = true;
      this.focusInput();
    }
  },
  methods: {
    // Focus the text input box:
    focusInput() {
      this.$nextTick(() => {
        this.$refs.textInput.focus();
      });
    },
    onEnter() {
      this.visible = false; // this allows to close popover by pressing enter on the input box
    },
    updateText() {
      if (!this.editableText) {
        this.editableText = DUNNING_DEFAULT_CTA_TEXT;
      }
      this.updateAttributes({
        text: this.editableText,
      });
    },
  },
});
</script>

<style lang="scss">
.ProseMirror {
  .cta-container {
    display: block; /* fixing popover positioning */
  }
  .cta-element {
    position: relative;
    display: block;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    padding: 0 5px;
    line-height: 1.5;
    color: #505050;
    font-size: 12px;
    font-weight: 700;
    margin-right: 6px;
    .grabber {
      display: none;
    }
    &:hover {
      border-top: 1px solid #e0e0e0;
      border-bottom: 1px solid #e0e0e0;
      .grabber {
        display: inline-block;
      }
      .delete-button {
        display: inline-block;
      }
    }
    &.selected {
      border-top: 1px solid #c0c0c0;
      border-bottom: 1px solid #c0c0c0;
    }
  }
}
.cta-popover.el-popover {
  position: relative; /* fixing popover positioning */
  padding: 0;
  background: transparent;
  border-radius: 0.75rem;
  top: 1.5rem;
  left: 0;
}

/* Remove popper arrow. Ideally do it passing popper options, but does not work! */
.cta-popover {
  margin-top: 0 !important;
}
.cta-popover .popper__arrow,
.cta-popover .popper__arrow::after {
  display: none !important;
}
.delete-button {
  position: absolute;
  top: 5px;
  right: 5px;
  display: none;
  /* other styles as needed */
}
</style>

